import { IUser } from "./IUser";

export function recalcAverages(u: IUser) {
  // Calculate PPR from current_game_rolls for LIVE updates during gameplay
  // NOTE: Permanent PPR will be calculated from game table data when loading/displaying stats
  // This just updates the live value during an active game
  const currentGameRolls = u.current_game_rolls || [];

  if (currentGameRolls.length > 0) {
    const totalRollPoints = currentGameRolls.reduce((sum, val) => sum + val, 0);
    u.avgPPR = +(totalRollPoints / currentGameRolls.length).toFixed(3);
  }
  // Don't set to 0 if no current rolls - preserve existing avgPPR from DB
}

